import maActionsButtons from '@/components/button-blue'
import maUploadDocumentItem from '@/modules/Document/views/handleDocumentContainer/components/documentUploadItem'
import maSpinner from '@/components/spinner'
import flowMixin from '@/modules/Flow/mixins/flowMixin'

export default {
  name: 'documentUploadStep',

  data: function() {
    return {
      acceptedFileExtensions: 'application/pdf, image/jpeg, image/png'
    }
  },

  mixins: [flowMixin],

  props: {
    disableActions: {
      type: Boolean,
      default: false
    },
    documents: {
      type: Array,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      default: ''
    }
  },

  components: {
    maActionsButtons,
    maUploadDocumentItem,
    maSpinner
  },

  methods: {
    handleDocumentInputChange(event) {
      const file = event.target.files[0]
      const fileType = file.type
      const isAcceptedFileExtension = this.acceptedFileExtensions.includes(fileType)
      if (isAcceptedFileExtension) this.$emit('onDocumentInputChange', file)
      event.target.value = ''
    },

    handleDocumentDeleteClick(documentId) { this.$emit('onDocumentDeleteClick', documentId) },

    handleDocumentDownloadClick({ documentId, documentName }) { this.$emit('onDocumentDownloadClick', { documentId, documentName }) },

    handleUploadFileClick() {
      const fileInput = this.$el.querySelector('[name="document-upload-input"]')
      fileInput.click()
    }
  }
}
